/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {MdPseudoCheckbox} from './pseudo-checkbox/pseudo-checkbox';
export class MdPseudoCheckboxModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  exports: [MdPseudoCheckbox],
  declarations: [MdPseudoCheckbox]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdPseudoCheckboxModule_tsickle_Closure_declarations() {
/** @type {?} */
MdPseudoCheckboxModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdPseudoCheckboxModule.ctorParameters;
}



export {MdPseudoCheckboxState,MdPseudoCheckbox} from './pseudo-checkbox/pseudo-checkbox';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
